import axiosInstance from '../axiosInterceptor/axiosInstance'

// Org-scoped v1 media presign: org id in the path, one file per call.
// Returns { id, url } — the reserved media id and the presigned S3 PUT url.
const getUploadPresignedUrl = async ({ orgId, fileName }) => {
  const response = await axiosInstance.post(`v1/orgs/${orgId}/media/presign-upload`, { fileName })
  return response?.data
}

export default getUploadPresignedUrl
